import styled from "styled-components"
import CarWrapper from "./CarWrapper"

const StyledCarsContent = styled.div`
  max-width: 800px;
  margin-top: 60px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    padding-left: 20px;
    padding-right: 20px;
  }
`

const StyledCarsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0 20px;
`

const CarsContent = () => {
  return (
    <StyledCarsContent>
      <StyledCarsWrapper>
        <CarWrapper
          title="MX-5 (1989~)"
          src="/img/aboutUs/cars/cartwo.jpg"
          link="https://www.mazda.com/en/innovation/stories/greatcar/roadster/01/"
        />
        <CarWrapper
          title="Cosmo (1975～)"
          src="/img/aboutUs/cars/carone.jpg"
          link="https://www.mazda.com/en/innovation/stories/greatcar/cosmo/"
        />

        <CarWrapper
          title="Capella (1970～)"
          src="/img/aboutUs/cars/carfour.jpg"
          link="https://www.mazda.com/en/innovation/stories/greatcar/capella/01/"
          marginTop={40}
        />
        <CarWrapper
          title="Savanna (1971～)"
          src="/img/aboutUs/cars/carthree.jpg"
          link="https://www.mazda.com/en/innovation/stories/greatcar/savanna/"
          marginTop={40}
        />
        <CarWrapper
          title="Luce (1966～)"
          src="/img/aboutUs/cars/carsix.jpg"
          link="https://www.mazda.com/en/innovation/stories/greatcar/luce/"
          marginTop={40}
        />
        <CarWrapper
          title="Cosmo Sport (1967～)"
          src="/img/aboutUs/cars/carfive.jpg"
          link="https://www.mazda.com/en/innovation/stories/greatcar/cosmo-sport/"
          marginTop={40}
        />
        <CarWrapper
          title="התלת-אופן Mazda-Go (1931～)"
          src="/img/aboutUs/cars/carseven.jpg"
          link="https://www.mazda.com/en/innovation/stories/greatcar/mazda-go/"
          marginTop={40}
        />
      </StyledCarsWrapper>
    </StyledCarsContent>
  )
}

export default CarsContent
